export class NewLocationInfo{
    constructor(
        public merchantId: String = '',
        public name: String = '',
        public directions: String = '',
        public phone: String = '',
        public manager: String = '',
        public county: String = '',
        public district: any = '',
        public parish: String = '',
        public town: any = '',
        public panels: any = null,
        public locationID: String = '',
        public numberTerminal: any = null,
        public bojLocationId: any = '',
        public kioskTerminals:any='' 
       
    ){}
}